<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> DISCIPLINA:</v-card-title>
        <ValidationObserver ref="observer">
          <div>
            <ValidationProvider
              v-slot="{ errors }"
              name="Disciplina"
              :rules="{ required: true, objectHasId: true }"
            >
              <v-select
                :error-messages="errors"
                :items="disciplinas"
                item-text="descricao"
                item-value="id"
                v-model="disciplina"
                return-object
                label="Selecione uma disciplina"
                solo
              />
            </ValidationProvider>
          </div>
        </ValidationObserver>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :dialog="dialog"
            @status="dialog = $event"
            color="blue darken-1"
            text
            @click="cancelar()"
            >Cancelar</v-btn
          >
          <v-btn
            v-if="typeModel === 'planosSemestraisInfantilPoli'"
            color="blue darken-1"
            text
            :to="{
              name: 'gestoesDeAulas.planoSemestralInfantil',
              params: { gestaoDeAulaId: gestaoDeAulasId },
              query: { disciplina: disciplina?.id },
            }"
            >OK</v-btn
          >
          <v-btn
            v-else-if="typeModel === 'planosSemestraisInfantilPoliPDF'"
            color="blue darken-1"
            text
            @click="gerarPlanoSemestralInfantil(gestaoDeAulasId, bimestre, disciplina)"
            >OK</v-btn
          >
          <v-btn v-else-if="typeModel === 'planos'" color="blue darken-1" text @click="submit">
            OK
          </v-btn>
          <v-btn
            v-else-if="typeModel === 'planosBimestraisPDF'"
            color="blue darken-1"
            text
            @click="gerarPlanoBimestral(gestaoDeAulasId, bimestre, disciplina)"
            >OK</v-btn
          >
          <v-btn
            v-else-if="typeModel === 'planosBimestraisInfantilPDF'"
            color="blue darken-1"
            text
            @click="gerarPlanoBimestralInfantil(gestaoDeAulasId, bimestre, disciplina)"
            >OK</v-btn
          >
          <v-btn
            v-else
            color="blue darken-1"
            text
            @click="gerarPlanoMensal(gestaoDeAulasId, bimestre, disciplina)"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { extend } from "vee-validate";

extend("objectHasId", {
  validate: (value) => value && value.id != null,
  message: "A disciplina é obrigatória",
});

export default {
  props: {
    disciplinas: {
      type: Array,
      required: true,
    },
    gestaoDeAulasId: {
      type: Number,
    },
    bimestre: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    typeModel: {
      type: String,
    },
  },

  watch: {
    dialog(val) {
      this.$emit("status", val);
    },
    typeModel(val) {
      this.type = val;
    },
  },
  data() {
    return {
      disciplina: null,
      disciplinasDaGestao: [],
      type: null,
    };
  },
  computed: {
    isDisabled() {
      return this.disciplinaSelecionada || !this.bimestre;
    },
  },
  methods: {
    async gerarPlanoSemestralInfantil(gestaoId, item, disciplina) {
      this.$emit("status", false);
      try {
        this.$loaderService.open("Gerando plano de aula...");
        await this.$services.relatoriosService.planoSemestralInfantil(
          parseInt(gestaoId, 10),
          parseInt(item.value, 10),
          parseInt(disciplina.id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
        this.$loaderService.close();
        this.$emit("status", false);
      }
    },
    submit() {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          this.gerarPlanoBimestral(this.gestaoDeAulasId, this.bimestre, this.disciplina);
        }
      });
    },
    submitSemetral() {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          this.gerarPlanoMensal(this.gestaoDeAulasId, this.bimestre, this.disciplina);
        }
      });
    },
    async gerarPlanoMensal(gestaoDeAulasId, bimestre, disciplina) {
      try {
        this.$loaderService.open("Gerando plano semestral...");
        await this.$services.relatoriosService.planoSemestral(
          parseInt(gestaoDeAulasId, 10),
          parseInt(bimestre, 10),
          parseInt(disciplina.id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    cancelar() {
      this.disciplinaSelecionada = null;
      this.bimestre = null;
      this.$emit("status", false);
    },
    async gerarPlanoBimestral(gestaoDeAulasId, bimestre, disciplina) {
      try {
        this.$loaderService.open("Gerando plano bimestral...");
        await this.$services.relatoriosService.planoBimestral(
          parseInt(gestaoDeAulasId, 10),
          parseInt(bimestre, 10),
          parseInt(disciplina.id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
        this.$loaderService.close();
      }
    },
    async gerarPlanoBimestralInfantil(gestaoId, item, disciplina) {
      this.$emit("status", false);
      try {
        this.$loaderService.open("Gerando plano de aula...");
        await this.$services.relatoriosService.planoBimestralInfantil(
          parseInt(gestaoId, 10),
          parseInt(item.value, 10),
          parseInt(disciplina.id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
        this.$loaderService.close();
        this.$emit("status", false);
      }
    },
  },
};
</script>
